<div class="modal-header">
  <h4 class="modal-title">{{(isNewArticle ? 'manageArticleMetaInfo.newArticle.title' : 'manageArticleMetaInfo.title') | translate}}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner d-flex flex-column">
    <form class="m-1" novalidate [formGroup]="form">
      <div class="mb-3 row col-md-12" *ngIf="articleMetaData?.articleIdMapping">
        <label class="col-md-4 col-form-label" for="articleId">{{'manageArticleMetaInfo.articleId' | translate}}{{(isNewArticle ? ' *' : '')}}</label>
        <input class="col-md-8 form-control"
               [class.is-invalid]="form.controls?.articleId?.touched && form.controls?.articleId?.invalid"
               type='text'
               formControlName="articleId"
               id="articleId">
        <div class="pl-3 invalid-feedback">{{getInputError(form.get('articleId'))}}</div>
      </div>

      <div class="mb-3 row col-md-12">
        <label class="col-md-4 col-form-label" for="oldArticleId">{{'manageArticleMetaInfo.oldArticleId' | translate}}</label>
        <input class="col-md-8 form-control"
               [class.is-invalid]="form.controls?.oldArticleId?.touched && form.controls?.oldArticleId?.invalid"
               type='text'
               formControlName="oldArticleId"
               id="oldArticleId">
        <div class="ps-3 invalid-feedback">{{getInputError(form.get('oldArticleId'))}}</div>
      </div>

      <div class="mb-3 row col-md-12">
        <label class="col-md-4 col-form-label">{{'manageArticleMetaInfo.articleType' | translate}}{{(isNewArticle ? ' *' : '')}}</label>
        <select class="col-md-8 form-control item-dropdown"
                #type
                formControlName="articleType"
                [class.is-invalid]="form.controls?.articleType?.touched && form.controls?.articleType?.invalid"
                [(ngModel)]="selectedArticleType">
          <option *ngFor="let type of articleTypes" [ngValue]="type.id">
            {{type.id }} - {{type.displayName }}
          </option>
        </select>
        <div class="pl-3 invalid-feedback">{{getInputError(form.get('articleType'))}}</div>
      </div>

      <div *ngIf="articleMetaData?.articleIdMapping">
        <div class="mb-3 row col-md-12">
          <label class="col-md-4 col-form-label" for="articleNo">{{'manageArticleMetaInfo.articleNo' | translate}}{{(isNewArticle ? ' *' : '')}}</label>
          <input class="col-md-8 form-control"
                 [class.is-invalid]="form.controls?.articleNo?.touched && form.controls?.articleNo?.invalid"
                 type='text'
                 formControlName="articleNo"
                 id="articleNo">
          <div class="pl-3 invalid-feedback">{{getInputError(form.get('articleNo'))}}</div>
        </div>

        <div class="mb-3 row col-md-12">
          <label class="col-md-4 col-form-label" for="eanNo">{{'manageArticleMetaInfo.eanNo' | translate}}</label>
          <input class="col-md-8 form-control"
                 [class.is-invalid]="form.controls?.eanNo?.touched && form.controls?.eanNo?.invalid"
                 type='text'
                 formControlName="eanNo"
                 id="eanNo">
          <div class="ps-3 invalid-feedback">{{getInputError(form.get('eanNo'))}}</div>
        </div>

        <div class="mb-3 row col-md-12">
          <label class="col-md-4 col-form-label" for="materialStatus">{{'manageArticleMetaInfo.materialStatus' | translate}}</label>
          <input class="col-md-8 form-control"
                 [class.is-invalid]="form.controls?.materialStatus?.touched && form.controls?.materialStatus?.invalid"
                 type='text'
                 formControlName="materialStatus"
                 id="materialStatus">
          <div class="ps-3 invalid-feedback">{{getInputError(form.get('materialStatus'))}}</div>
        </div>

        <div class="mb-3 row col-md-12">
          <label class="col-md-4 col-form-label" for="lastCall">{{'manageArticleMetaInfo.lastCall' | translate}}</label>
          <input class="col-md-8 form-control" id="lastCall" type='text' formControlName="lastCall" id="lastCall">
        </div>

        <div class="mb-3 row col-md-12">
          <label class="col-md-4 col-form-label" for="minimumStockLevel">{{'manageArticleMetaInfo.minimumStockLevel' | translate}}</label>
          <input class="col-md-8 form-control"
                 [class.is-invalid]="form.controls?.minimumStockLevel?.touched && form.controls?.minimumStockLevel?.invalid"
                 type='text'
                 id="minimumStockLevel"
                 formControlName="minimumStockLevel"
                 id="minimumStockLevel">
          <div class="ps-3  invalid-feedback">{{getInputError(form.get('minimumStockLevel'))}}</div>
        </div>

        <div class="mb-3 row col-md-12">
          <div class="form-check ms-3">
            <input class="col-md-4 py-0 form-check-input" type='checkbox' [(ngModel)]="articleMetaData.articleIdMapping.publicGlobal" id="publicGlobal" formControlName="publicGlobal">
            <label class="form-check-label m-0" for="publicGlobal">{{'manageArticleMetaInfo.publicGlobal' | translate}}</label>
          </div>
        </div>

        <div class="mb-3 row col-md-12">
          <div class="form-check ms-3">
            <input class="col-md-4 py-0 form-check-input" type='checkbox' [(ngModel)]="articleMetaData.articleIdMapping.isFullArticle" id="isFullArticle" formControlName="isFullArticle">
            <label class="form-check-label m-0" for="isFullArticle">{{'manageArticleMetaInfo.isFullArticle' | translate}}</label>
          </div>
        </div>

      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">
    {{'global.label.cancel' | translate}}
  </button>
  <button [disabled]="isNewArticle ? form.invalid : !form.dirty || form.invalid" class="btn btn-primary" (click)="save()">
    {{(isNewArticle ? 'manageArticleMetaInfo.label.createNewArticle' : 'global.label.save') | translate}}
  </button>
</div>
